import { apiService } from './apiService';

export function getDiningTableService(data) {
    return apiService({
        method: 'POST',
        url: '/dining-table/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdDiningTableService(id) {
    return apiService({
        method: 'GET',
        url: '/dining-table/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getBySlugDiningTableService(slug) {
    return apiService({
        method: 'GET',
        url: '/dining-table/slug/' + slug,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function addDiningTableService(data) {
    return apiService({
        method: 'POST',
        url: '/dining-table',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updateDiningTableService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/dining-table/' + id,
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function deleteDiningTableService(id) {
    return apiService({
        method: 'DELETE',
        url: '/dining-table/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getTableBySlugDiningTableService(slug) {
    return apiService({
        method: 'GET',
        url: '/front/dining-table/' + slug,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
